export const AspectRatios = {
	standardVideo: 640 / 416,
	standardVideoCss: '640/416',
	invertedStandardVideoCss: '416/640',
}
